import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
const notifications = [{
  name: 'Marcelo R.',
  location: 'San Justo',
  pack: 'Pack CI 6×6 + Gestión Profesional 🏆'
}, {
  name: 'Daniela F.',
  location: 'Moreno',
  pack: 'Pack CI 6×6 📘'
}, {
  name: 'Pablo A.',
  location: 'Rosario',
  pack: 'Pack CI 6×6 + Gestión Profesional 🏆'
}];
export function PurchaseNotification() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay before showing first notification
    const initialDelay = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (!isVisible) {
      // When hidden, wait 15 seconds then show next
      const timer = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % notifications.length);
        setIsVisible(true);
      }, 15000);
      return () => clearTimeout(timer);
    } else {
      // When visible, hide after 5 seconds
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [isVisible]);
  const current = notifications[currentIndex];
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-323">
      <AnimatePresence data-id="element-324">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 50,
        x: -20
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 400,
        damping: 25
      }} className="bg-white rounded-lg shadow-2xl border border-beige-dark p-4 max-w-sm pointer-events-auto flex gap-3" data-id="element-325">
            <div className="shrink-0 pt-1" data-id="element-326">
              <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-327" />
            </div>
            <div className="flex-grow pr-4" data-id="element-328">
              <p className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-1" data-id="element-329">
                Compra verificada
              </p>
              <p className="text-sm text-charcoal" data-id="element-330">
                <span className="font-bold" data-id="element-331">{current.name}</span> de{' '}
                {current.location} compró
              </p>
              <p className="text-sm font-semibold text-gold mt-0.5" data-id="element-332">
                {current.pack}
              </p>
            </div>
            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-333">
              <X className="w-4 h-4" data-id="element-334" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}